import { ITypedModel } from 'core-ts-types';
import { merge } from 'lodash4';

export interface IApStudentDetailsModel {
  birthdate: string;
  email: string;
  first_name: string;
  first_term: number;
  high_school: string;
  id: string; // Same as nk
  user_id: number; // actual user id.
  last_name: string;
  nk: string;
  phone: string;
  planned_term: number[];
  username: string;
  want_fin_aid: false;
}

export class ApStudentDetailsModel implements ITypedModel<IApStudentDetailsModel> {
  birthdate: string;
  email: string;
  first_name: string;
  first_term: number;
  high_school: string;
  id: string;
  user_id: number;
  last_name: string;
  nk: string;
  phone: string;
  planned_term: number[];
  username: string;
  want_fin_aid: false;

  constructor() {
    this.clear();
  }

  read(): IApStudentDetailsModel {
    return this;
  }

  clear(): this {
    return this;
  }

  write(model: Partial<ApStudentDetailsModel>): this {
    merge(this, model);
    return this;
  }

  static build(): ApStudentDetailsModel {
    return new ApStudentDetailsModel();
  }
}

angular
  .module('capability-ng-academic-planner')
  .factory('ngApStudentDetailsModel', (): ApStudentDetailsModel => ApStudentDetailsModel.build());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/student_details/models/ap_student_details_model.ts